import { Component, Input } from '@angular/core';
import { IExpertScreenerActionBase } from '@techspert-io/surveys';
import 'moment-timezone';

@Component({
  selector: 'app-screener-box',
  templateUrl: './screener-box.component.html',
  styleUrls: ['./screener-box.component.scss'],
  standalone: false,
})
export class ScreenerBoxComponent {
  @Input() screenerConfig: IExpertScreenerActionBase;
}
